"use client";

import { useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";

import { captureStoreLinkTouch, captureUtmFromLocation } from "@/lib/utm";

/**
 * Captures UTM + landing path into sessionStorage on first paint / navigation.
 * Mount once under the root layout (client island).
 */
export default function AttributionCapture() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    const search = searchParams?.toString();
    const query = search ? `?${search}` : "";
    captureUtmFromLocation(query, pathname ?? "/");
    captureStoreLinkTouch(query);
  }, [pathname, searchParams]);

  return null;
}
